export const selectedDot = require('@/modules/profiles/assets/dot-selected.svg');
export const unselectedDot = require('@/modules/profiles/assets/dot-unselected.svg');